import {useEffect} from 'react';

import {useGetNotificationGlobalSubscription} from '@/gql-codegen/generated';
import {useNotificationStore} from '@/hooks/global-stores/notification.store';

const NotificationProvider = ({children}: {children: React.ReactNode}) => {
  const [{data}] = useGetNotificationGlobalSubscription();

  const setNotification = useNotificationStore(s => s.addNotification);

  useEffect(() => {
    if (data?.NotificationGlobal) {
      setNotification(data?.NotificationGlobal);
    }
  }, [data, setNotification]);

  return children;
};

export default NotificationProvider;
